import { useMemo } from "react";
import { money, num, dateShort } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export default function CustomerSummary({ open, onOpenChange, form, result, financial }) {
  const s = result?.stack_result;

  const text = useMemo(() => {
    if (!s || !financial) return "";
    const service = form.fedex_service_type === "FEDEX_FREIGHT_ECONOMY" ? "FedEx Freight Economy (LTL)" : "FedEx Freight Priority (LTL)";
    const exp = new Date();
    exp.setDate(exp.getDate() + 14);
    return [
      `PREMIER HANDLING SOLUTIONS — FREIGHT QUOTE`,
      form.quote_ref ? `Reference: ${form.quote_ref}` : null,
      form.customer_name ? `Prepared for: ${form.customer_name}` : null,
      ``,
      `Product: ${s.product_name}`,
      `Quantity: ${num(s.quantity)}`,
      `Ship to: ${[form.dest_city, form.dest_state].filter(Boolean).join(", ")} ${form.destination_zip}`.trim(),
      `Total handling units (stacks): ${num(s.total_stack_footprints)}`,
      `Total shipment weight: ${num(s.total_cargo_weight)} lbs`,
      `Freight class: ${result.calculated_class || "—"}`,
      `Estimated delivery method: ${service}`,
      ``,
      `FREIGHT PRICE: ${money(financial.sell_price)}`,
      ``,
      `Assumptions:`,
      `• Pricing based on dimensions/weight provided and standard dock-to-dock service unless noted.`,
      `• Accessorials included as selected; additional services may change pricing.`,
      ``,
      `Exclusions: duties, taxes, storage, detention, redelivery, and services not listed above.`,
      `Quote valid through: ${dateShort(exp.toISOString())}.`,
    ].filter((l) => l !== null).join("\n");
  }, [s, financial, form, result]);

  const copy = () => {
    navigator.clipboard.writeText(text);
    toast.success("Customer quote copied to clipboard");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="customer-summary-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Customer Quote Summary</DialogTitle>
          <DialogDescription>Copy-ready freight summary. Internal cost and margin are hidden.</DialogDescription>
        </DialogHeader>
        <pre className="max-h-[55vh] overflow-auto whitespace-pre-wrap rounded-md border border-border bg-background p-4 text-sm leading-relaxed">
          {text || "Calculate a quote first."}
        </pre>
        <p className="text-xs text-muted-foreground">Internal carrier cost and margin are intentionally hidden from this view.</p>
        <Button onClick={copy} disabled={!text} data-testid="copy-customer-quote" className="bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90">
          <Copy className="mr-1.5 h-4 w-4" /> Copy to Clipboard
        </Button>
      </DialogContent>
    </Dialog>
  );
}
